import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { getCreditBalance, getCreditHistory } from './api';

/**
 * Query for user's credit balance with auth-awareness and auto-refresh.
 * Only fetches when fully authenticated (auth complete + user profile loaded).
 * Auto-refreshes every 30 seconds.
 *
 * NOTE: Disabled - balance API not implemented yet
 */
export function useCreditBalance() {
  // const isAuthenticated = useIsAuthenticated();
  // const authLoading = useIsAuthLoading();
  // const userProfile = useUserProfile();

  return useQuery({
    queryKey: queryKeys.credits.balance(),
    queryFn: getCreditBalance,
    // NOTE: Disabled - balance API not implemented yet
    enabled: false,
    // enabled: isAuthenticated && !authLoading && !!userProfile,
    refetchInterval: 30000, // 30 seconds auto-refresh
    staleTime: 10000, // Consider stale after 10 seconds
  });
}

export function useCreditHistory(page: number = 1, pageSize: number = 50) {
  return useQuery({
    queryKey: queryKeys.credits.history(page, pageSize),
    queryFn: () => getCreditHistory(page, pageSize),
    // NOTE: Disabled - history API not implemented yet
    enabled: false,
  });
}
